const CONSIGNEE_LABEL_LIST = [
  { label: "Consignee Name", fieldName: "customerName" },
  { label: "Consignee Address", fieldName: "address" },
  { label: "City", fieldName: "city" },
  { label: "Customer Acc #", fieldName: "customerCode" },
  { label: "Consignee State", fieldName: "state" },
  { label: "Consignee Zip", fieldName: "zip" },
  { label: "Customer Phone", fieldName: "customerPhone" },
  { label: "Delivery Window", fieldName: "deliveryWindow" },
  { label: "Priority", fieldName: "priority" },
];

const SHIPPER_LABEL_LIST = [
  { label: "Shipper Name", fieldName: "shipperName" },
  { label: "Shipper Address", fieldName: "shipperAddress" },
];

const LOADING_ZONE_LIST = ["F", "M", "R", "T"];
const TAIL_LOADING_ZONE = "T"

export {
  CONSIGNEE_LABEL_LIST,
  SHIPPER_LABEL_LIST,
  LOADING_ZONE_LIST,
  TAIL_LOADING_ZONE,
};
